import React from 'react';

import AdvancedIcon from '@core/assets/icons/proficiency-advanced.svg';
import AdvancedMiniIcon from '@core/assets/icons/proficiency-advanced-small.svg';
import IntermediateIcon from '@core/assets/icons/proficiency-intermediate.svg';
import IntermediateMiniIcon from '@core/assets/icons/proficiency-intermediate-small.svg';
import BeginnerIcon from '@core/assets/icons/proficiency-beginner.svg';
import BeginnerMiniIcon from '@core/assets/icons/proficiency-beginner-small.svg';

import classes from './ProficiencyBadge.module.scss';

const ProficiencyBadge = ({ proficiency, isMini = false }) => {

    if (proficiency === 'advanced')
        return isMini ? <AdvancedMiniIcon /> : <AdvancedIcon />;
    else if (proficiency === 'intermediate')
        return isMini ? <IntermediateMiniIcon /> : <IntermediateIcon />;
    else if (proficiency === 'beginner')
        return isMini ? <BeginnerMiniIcon /> : <BeginnerIcon />;
    else
        return <div></div>;
};

export default ProficiencyBadge;